import React from 'react';
import { Field, FieldProps } from 'formik';
import { TextField, Autocomplete } from "@mui/material";

interface Option {
  is_selected: boolean;
  label: string;
  value: string;
}

interface Props {
  label: string;
  name: string;
  placeholder: string;
  options: Option[];
  isRequired: boolean;
  errorMessage: string;
  onChange:(field:any)=>void;
  formField:any
}

const SelectField: React.FC<Props> = ({
  label,
  name,
  placeholder,
  options,
  isRequired,
  errorMessage,
  onChange,
  formField
}) => (
  <Field name={name}>
    {({ field, form, meta }: FieldProps) => {
      const selectedOption = options.find(option => option.is_selected) || null;

      const handleValueChange=(value:any)=>{
        onChange({...formField,value:value.value ,options:formField.options.map((option: { value: string; }) => ({
          ...option,
          is_selected: option.value === value.value
        }))})
      }

      return (
        <Autocomplete
          id={name}
          options={options}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              label={`${label} ${isRequired ? "*":""}`}
              placeholder={placeholder}
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error ? errorMessage : ""}
              fullWidth
            />
          )}
          onChange={(_, value: Option | null) => {
            form.setFieldValue(name, value ? value.value : '')
            handleValueChange(value)
          }}
          onBlur={() => form.setFieldTouched(name, true)}
          value={field.value ? options.find(option => option.value === field.value) : selectedOption}
          isOptionEqualToValue={(option, value) => option.value === value?.value }
        />
      );
    }}
  </Field>
);

export default SelectField;
